import React from 'react';
import { DefaultLayout as Layout } from '../../../layouts/Default/DefaultLayout';
import { ManageInvoices } from '../../../components/billing/ManageInvoices/ManageInvoices';

export const ManageInvoicesPage = () => {
  return (
    <Layout>
      <h1 id="primaryPageTitle">Manage Invoices</h1>
      <ManageInvoices />
    </Layout>
  );
};
